/* globals jQuery, wordpress_globals */

import "../sass/theme.scss";

import $ from 'jquery';
import svgxhr from 'webpack-svgstore-plugin/src/helpers/svgxhr';
import WPAjax from './modules/wp-ajax';
import CursorCircle from "./modules/cursor-circle";
import Menu from './modules/menu';
import ModalBlock from "./modules/modal-block";
import Swiper from 'swiper/swiper.esm';
import Accordion from "./modules/accordion";
import FontSizeCalculator from './modules/font-size-calculator';
import Videos from './modules/videos';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import { Autoplay } from "swiper";
import Language from './modules/Language';
import FlipBook from './modules/flipbook';
import ix from './modules/ix';
import WOW from "wow.js";
import { CountUp } from 'countup.js';
import ContactHeader from './modules/contact-header';
import Nav from './modules/nav'
import wpforms from "./modules/wpforms";

import "./modules/PropsBanner";

window.namespace = {
	init: function() {
		if(MODE && MODE === 'production') {
			console.log = function() {};
			console.warning = function() {};
			console.warn = function() {};
		}
		const WOW = require("wow.js");
		this.wow = new WOW({
			offset: 150,
			callback: (el) => {
				if(el.classList.contains('stat')) {
					let numberEl = el.querySelector('.stat__figure');
					let number = parseFloat(numberEl.innerHTML)

					if(!isNaN(number)) {
						let args = {
							duration: 2.6,
							easingFn: function (t, b, c, d) {
								let ts = (t /= d) * t,
									tc = ts * t;

								return b + c * (tc + -3 * ts + 3 * t);
							}
						}

						let count = new CountUp(numberEl, number, args);
						if (!count.error) {
							count.start();
						} else {
							console.warn(count.error);
						}
					}
				}
			}
		});
		this.wow.init();

		let cursorCircle = null;
		let width = document.body.clientWidth;

		if(width >= 1200) {
			let circleClasses = ['cursor-circle'];
			let circleClassesActive = circleClasses;
			if(document.body.classList.contains('error404')) {
				circleClasses = ['cursor-circle', 'cursor-circle--smiley'];
				circleClassesActive = ['cursor-circle', 'cursor-circle--smiley', 'cursor-circle--frowny']
			}


			cursorCircle = new CursorCircle({
				hex: '#FF385b',
				defaultSize: 20,
				stringDelay: 250,
				smallSize: 53,
				mediumSize: 76,
				largeSize: 100,
				defaultClasses: circleClasses,
				anchorLinks: {
					interact: true,
					hoverSize: 'small',
					string: "",
					exclusions: ['.chungus__link', '.test']
				}
			})

			if(document.body.classList.contains('error404')) {
				let errorLink = document.querySelector('.error404__link a');
				if(errorLink) {
					errorLink.addEventListener('mouseenter', e => {
						cursorCircle.classes = circleClassesActive;
						cursorCircle.updateCircle();
					});

					errorLink.addEventListener('mouseleave', e => {
						cursorCircle.classes = circleClasses;
						cursorCircle.updateCircle();
					})
				}
			}
		}

		this.helpers.initSvg();
		this.helpers.initAjax(cursorCircle);
		this.helpers.initSwipers(cursorCircle);
		this.helpers.calculateScrollBarWidth();
		FlipBook.init();
		new FontSizeCalculator();
		if(!document.body.classList.contains('error404')) {
			new Language();
		}
		ix.init();
		ContactHeader.init();
		Nav.init();
		if(navigator.userAgent.indexOf('MSIE')!==-1
			|| navigator.appVersion.indexOf('Trident/') > -1) {
			console.log("Main.js - Videos not paused on IE11");
		} else {
			Videos.init();
		}
		wpforms.init();

		Menu.init( this.wow, cursorCircle, "#menu", '.btn--open', '.btn--close');

		const OPEN_HEX = "#171717";
		const CLOSE_HEX = "#FF385b";
		/** When we begin hovering on the form change the cursor to black */
		let form = document.querySelector('.wpforms-container');
		if(form) {
			form.addEventListener('mouseenter', e => {
				if (e.target === form && cursorCircle) {
					cursorCircle.currentHex = OPEN_HEX;
					cursorCircle.options.hex = OPEN_HEX;
					cursorCircle.update();
				}
			})

			form.addEventListener('mouseleave', e => {
				if (e.target === form && cursorCircle) {
					cursorCircle.currentHex = CLOSE_HEX;
					cursorCircle.options.hex = CLOSE_HEX;
					cursorCircle.update();
				}
			})
		}

		Array.from(document.querySelectorAll('video.circle-el')).forEach(video => {
			video.addEventListener('play', (e) => {
				if(cursorCircle) {
					e.target.dataset.circleText = "Pause";
					cursorCircle.currentString = "Pause";
					cursorCircle.update();
				}
			})

			video.addEventListener('pause', e => {
				if(cursorCircle) {
					e.target.dataset.circleText = "Play";
					cursorCircle.currentString = "Play";
					cursorCircle.update();
				}
			})
		})

		let gTagLinks = document.querySelectorAll('.track-gtag');
		Array.from(gTagLinks).forEach(link => {
			link.addEventListener('click', e => {
				if(typeof gtag !== "undefined") {
					let eventCategory = 'soft-conversion';
					let eventAction = link.dataset.eventAction || 'click';
					let eventLabel = link.dataset.eventLabel || link.href;
					let eventValue = link.dataset.eventValue || null;
					gtag('event', eventAction, {
						'event_category': eventCategory,
						'event_label': eventLabel,
						'value': eventValue
					});
				}
			});
		});

		let modalBlocks = new ModalBlock({
			modalBlocks: document.querySelectorAll('.modal-container'),
			modalButtons: '.modal-btn',
			afterFunction: () => {
				// console.log("main.js - Function running after modal open.");
				if(cursorCircle) {
					cursorCircle.initialiseElements();
				}
				// let modal = document.querySelector('.modal');
				// let workModal = document.querySelector('.work-modal');
			}
		});

		let accordions = new Accordion(() => {
			if(width < 1200) {
				const filtersSwiper = new Swiper('.filters__swiper', {
					spaceBetween: 10,
					slidesPerView: 'auto',
					slidesPerGroup: 1,
					loop: false,
				})
			}
		});

		// cursorCircle.currentHex = '#000000'

		//Allow user to interrupt auto-scrolling
		$(document).bind('scroll mousedown wheel keyup', function(e) {
			if(e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
				$(document.scrollingElement).stop();
			}
		});

		let scrollButtons = document.querySelectorAll('.scroll-to-top');
		Array.from(scrollButtons).forEach(scrollButton => {
			scrollButton.addEventListener('click', e => {
				e.preventDefault();

				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth',
				});
			});
		});

		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener('click', function (e) {
				e.preventDefault();

				document.querySelector(this.getAttribute('href')).scrollIntoView({
					behavior: 'smooth'
				});
			});
		});
	},
	helpers: {
		requireAll: function(r) {
			r.keys().forEach(r);
		},
		initSvg: function (){
			svgxhr({
				filename: './wp-content/themes/class/dist/sprite.svg', //URL to fetch
			});
		},
		calculateScrollBarWidth: function() {
			// Creating invisible container
			const outer = document.createElement('div');
			outer.style.visibility = 'hidden';
			outer.style.overflow = 'scroll'; // forcing scrollbar to appear
			outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
			document.body.appendChild(outer);

			// Creating inner element and placing it in the container
			const inner = document.createElement('div');
			outer.appendChild(inner);

			// Calculating difference between container's full width and the child width
			const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

			// Removing temporary elements from the DOM
			outer.parentNode.removeChild(outer);

			// console.warn("Scrollbar width: " + scrollbarWidth);
			let styleSheet = document.createElement("style");
			styleSheet.innerHTML = `
			.options--scrollbar { 
				right: ${scrollbarWidth}px !important
			 }
			 @media only screen and (max-width: 1199px) {
				 .options--mobile-full-width {
					width: calc(100% - ${scrollbarWidth}px) !important;
				 }
			 }
			 
			 @media
			`;
			document.head.appendChild(styleSheet);
			return scrollbarWidth;
		},
		initAjax: function(cursorCircle){
			//the pattern for the work pattern, 1 = 1 image per row, 2 = 2 images per row etc.
			let theQuantities = [1, 2, 2, 3, 1, 2];

			let workAjax = new WPAjax("work", {
				preProcesses: function(_this) {
					let quantities = [1, 2, 2, 3, 1, 3];
					let quantity;
					quantity = quantities[_this.runCount % quantities.length];
					_this.options.loadQuantity = quantity;
				},
				postProcesses: (_this) => {
					if(cursorCircle) {
						cursorCircle.initialiseElements()
					}
				},
				offset: 12,
			}, {
				useBtn: false,
				btn: document.querySelector('.test-btn'),
				scrollLoad: true,
			});

			let thoughtAjax = new WPAjax("post", {
				postProcesses: (_this) => {
					if(cursorCircle) {
						cursorCircle.initialiseElements();
					}
				},
				offset: 8,
				loadQuantity: 8,
			}, {
				useBtn: false,
				scrollLoad: true,
			});

			let categories = document.querySelectorAll('input[name="category"]');
			let resetButton = document.querySelector('.filters__clear');
			if(resetButton) {
				resetButton.addEventListener('click', e => {
					let tempCat = null;
					thoughtAjax.listCategories = true;
					Array.from(categories).forEach(cat => {
						if(cat.checked === true) {
							cat.checked = false;
							tempCat = cat;
						}
					})
					let event = new Event('change');
					if(tempCat) {
						tempCat.dispatchEvent(event);
					}
				});
			}
			let disableCategories = (categoryIds) => {
				Array.from(categories).forEach(catCheckbox => {
					let catValue = parseInt(catCheckbox.value);
					if(!categoryIds.includes(catValue)) {
						catCheckbox.disabled = true;
					} else {
						catCheckbox.disabled = false;

					}
					// catCheckbox.disabled = categoryI/**/ds.includes(catValue) ? "false" : 'true';
				});
			}

			let reenableAllCategories = () => {
				Array.from(categories).forEach(catCheckbox => {
					catCheckbox.disabled = false;
				});
			}

			Array.from(categories).forEach(catCheckbox => {
				catCheckbox.addEventListener('change', e => {
					let categories = [];
					thoughtAjax.listCategories = true;
					let checkedCategories = document.querySelectorAll('input[name="category"]:checked');
					if(checkedCategories.length === 0) {
						reenableAllCategories();
					}
					Array.from(checkedCategories).forEach(cat => {
						categories.push(cat.value);
					})
					let filterBtn = document.querySelector('#filter-count');

					if(filterBtn && checkedCategories.length > 0) {
						filterBtn.innerHTML = "(" + checkedCategories.length + ")";
					} else {
						filterBtn.innerHTML = "";
					}

					if(categories) {
						thoughtAjax.options.queryArgs.category = {
							name: 'category',
							value: categories
						}
						thoughtAjax.taxonomy = "category";
						thoughtAjax.taxonomyValue = categories;
						thoughtAjax.options.queryArgs.updatePostCount = true;
					} else {
						delete thoughtAjax.options.queryArgs.category;
						thoughtAjax.taxonomy = null;
						thoughtAjax.taxonomyValue = null;
						thoughtAjax.options.queryArgs.updatePostCount = false;
					}

					thoughtAjax.options.append = false;
					thoughtAjax.options.offset = 0;
					thoughtAjax.runCount = 0;
					thoughtAjax.options.loadQuantity = 2;
					thoughtAjax.loading = false;
					thoughtAjax.options.postProcesses = (_this) => {
						if(cursorCircle) {
							cursorCircle.initialiseElements();
						}
						if(_this.results && _this.results.categories_with_results) {
							disableCategories(_this.results.categories_with_results);
							// console.log("Found results: ", _this.results.categories_with_results);
						}
						_this.options.append = true;
						_this.options.loadQuantity = 2;
						thoughtAjax.options.queryArgs.updatePostCount = false;
						let postCountInput = document.querySelector('input[name="post-count"]');
						if(postCountInput) {
							_this.postCount = parseInt(postCountInput.value);
						} else {
							_this.postCount = container.dataset.postCount;
						}
						_this.options.postProcesses = (_this) => {
							if(cursorCircle) {
								cursorCircle.initialiseElements();
							}

							if(_this.results && _this.results.categories_with_results) {
								disableCategories(_this.results.categories_with_results);
								// console.log("Found results: ", _this.results.categories_with_results);
							}
						}
					}
					thoughtAjax.postAjax("post", thoughtAjax.container, null);
					thoughtAjax.listCategories = false;
				});
			})
		},
		initSwipers: function(cursorCircle) {
			let width = document.body.clientWidth;

			Swiper.use(Autoplay);
			/** Stats slider */

			const statSwiperSpacing = (width >= 1200) ? 60 : 45;

			const statSwiper = new Swiper('.stats-slider__swiper', {
				// sliderPerPage: 'auto',
				spaceBetween: statSwiperSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: false,
				autoplay: {
					delay: 5000,
				},
			})

			const partnerSwiperSpacing = (width >= 1200) ? 30 : 20;

			const partnerSwiper = new Swiper('.partner-block__swiper', {
				spaceBetween: partnerSwiperSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: true,
				center: true,
				on: {
					init: () => {
						if(cursorCircle) {
							cursorCircle.initialiseElements();
						}
					},
					update: () => {
						if(cursorCircle) {
							cursorCircle.initialiseElements();
						}
					}
				},
				autoplay: {
					delay: 5000,
				},
			})

			const quoteSwiperSpacing = (width >= 1200) ? 80 : 40;

			const quoteSwiper = new Swiper('.quote-slider__swiper', {
				spaceBetween: quoteSwiperSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: false,
			})

			const imageSwiperSpacing = (width >= 1200) ? 20 : 7;
			// const imageSwiperCenterSlides = (width >= 1200) ? true : false;

			const imageSwiper = new Swiper('.image-slider__swiper', {
				spaceBetween: imageSwiperSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: true,
				roundLengths: true,
				centeredSlides: true,
				autoHeight: true,
				// preloadImages: false,
				autoplay: {
					delay: 5000,
				},
				on: {
					init: function () {
					    this.updateSize();
						this.updateAutoHeight(100);
					}
				}
			})

			const featuredThoughtSpacing = (width >= 1200) ? 50 : 10;

			const featuredThoughtSwiper = new Swiper('.featured-thoughts__swiper', {
				spaceBetween: featuredThoughtSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: false,
			})

			const featuredThoughtsTextSpacing = (width >= 1200) ? 65 : 30;

			const featuredThoughtTextSwiper = new Swiper('.featured-thoughts-text__swiper', {
				spaceBetween: featuredThoughtsTextSpacing,
				slidesPerView: 'auto',
				slidesPerGroup: 1,
				loop: false,
			})

			if(width >= 767) {
				const workSliderSpaceBetween = (width >= 1200) ? 50 : 30;
				const workSlider = new Swiper('.work-slider__swiper', {
					spaceBetween: workSliderSpaceBetween,
					slidesPerView: 'auto',
					slidesPerGroup: 1,
					loop: false,
				});
			}

			if(width < 767) {
				// const tabSwiper = new Swiper('.header__tag-swiper', {
				// 	spaceBetween: 15,
				// 	slidesPerView: 'auto',
				// 	slidesPerGroup: 1,
				// 	loop: false,
				// })
			}

			if(width < 1200) {
				const flipbookSwiper = new Swiper('.flip-book__swiper', {
					spaceBetween: 25,
					slidesPerView: 'auto',
					slidesPerGroup: 1,
					loop: false,
				})
			}
		},
	}

	//Prefer creating new modules when appropriate, rather than adding functions here
	//If you need something to be globally accessible, you can assign an imported module to this namespace
	//I.e import Contact from './contact';
	//    window.namespace.Contact = Contact;
};

window.namespace.init();


if(typeof NodeList.prototype.forEach !== 'function'){
	NodeList.prototype.forEach = Array.prototype.forEach;
}

// SVG Sprite Loader
window.namespace.helpers.requireAll(require.context('../images/icons/', true, /\.svg$/));
